/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SessionSummary,
  SessionSummary$inboundSchema,
} from "./sessionsummary.js";

/**
 * Result of listing org-scoped chat sessions
 */
export type ListSessionsResult = {
  /**
   * Cursor for next page
   */
  nextCursor?: string | undefined;
  /**
   * List of chat session summaries
   */
  sessions: Array<SessionSummary>;
};

/** @internal */
export const ListSessionsResult$inboundSchema: z.ZodMiniType<
  ListSessionsResult,
  unknown
> = z.pipe(
  z.object({
    next_cursor: z.optional(z.string()),
    sessions: z.array(SessionSummary$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listSessionsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListSessionsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSessionsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSessionsResult' from JSON`,
  );
}
